import { notification } from 'antd';
import { NotificationPlacement } from 'antd/es/notification/interface';
import React, { useEffect, useState } from 'react';

export type Props = {
    message: string
    duration: number
    type: string
    onClose: () => void
    messageNonce: any
}

const NotificationContext = React.createContext({ messageText: '', setMessageText: (_m: string) => {} });

const Notification = ({message, duration, type, onClose, messageNonce}: Props) => {
    const [messageText, setMessageText] = useState<string>('')
    const [api, context] = notification.useNotification();
    const openNotification = (placement: NotificationPlacement) => {

        const config = {
            message: type,
            description: <NotificationContext.Consumer>{({ messageText }) => `${messageText}`}</NotificationContext.Consumer>,
            placement,
            onClose: onClose,
            duration: duration
        }

        switch(type){
            case 'Error':
                api.error(config);
                break;
            case 'Warn':
                api.warning(config);
                break;
            case 'Info':
                api.info(config);
                break;
            case 'Success':
                api.success(config);
                break;
        }
      };

    useEffect(() => {
        if(message !== ''){
            setMessageText(message)
            openNotification('topRight')
        }
    }, [message, messageNonce])

    return <NotificationContext.Provider value={{messageText, setMessageText}}>
        {context}
    </NotificationContext.Provider>
}

export default Notification